import { render, staticRenderFns } from "./SecaoValor.vue?vue&type=template&id=0da1a527&"
import script from "./SecaoValor.vue?vue&type=script&async=true&lang=js&"
export * from "./SecaoValor.vue?vue&type=script&async=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports